module.exports = __webpack_public_path__ + "img/p3_5.b62a80b8.png";